import { action } from 'satcheljs';
import { ClientItemId } from 'owa-client-ids';
import { ReadingPaneEntrySourceType } from 'owa-calendar-forms-common/lib/schema/ReadingPaneEntrySourceType';

export default action(
    'popOutReadingPane',
    (itemId: ClientItemId, entrySource: ReadingPaneEntrySourceType) => ({ itemId, entrySource })
);
